import React, { lazy } from "react";
import UpdateDerogation from "./derogation/update-derogation";
import {
  DASHBOARD_SEO,
  PAYMENT_SEO,
  RECEIPTS_SEO,
  // eslint-disable-next-line no-unused-vars
  PROFILE_SEO,
  HELP_SEO,
  LOGIN_SEO,
} from "./config/seoPages";

const SharedLayout = lazy(() => import("./SharedLayout"));

// Lazy-loaded components
const Login = lazy(() => import("./login"));
const Bien = lazy(() => import("./bien"));
const Payement = lazy(() => import("./payement"));
const Seccuss = lazy(() => import("./secuss-payement"));
const ErrorPayement = lazy(() => import("./error/ErrorPayement"));
const ErrorReponse = lazy(() => import("./error/ErrorReponse"));
const ErrorRedirectionPayement = lazy(() =>
  import("./error/ErrorRedirectionPayement")
);
const ErrorNetwork = lazy(() => import("./error/ErrorNetwork"));
const QuittancesPayees = lazy(() => import("./quittancesPayees"));
const QuittancesNonPayees = lazy(() => import("./quittancesNonPayees"));
const Error404 = lazy(() => import("./error/Error404"));
const MyOperations = lazy(() => import("./myOperations"));
const NewDerogation = lazy(() => import("./derogation/new-derogation"));
const Derogation = lazy(() => import("./derogation"));
const Doleance = lazy(() => import("./doleance"));
const NewDoleance = lazy(() => import("./doleance/new-doleance"));
const Miseendemeure = lazy(() => import("./miseendemeure"));
const MovementContrat = lazy(() => import("./movement-contrat"));
const Sondage = lazy(() => import("./sondage"));

/**
 * SEO MAPPING: Maps route paths to their SEO configurations
 * 
 * Usage in component: 
 *   import { useSEO } from '../utils/SEOHelper';
 *   import { DASHBOARD_SEO } from '../config/seoPages';
 *   
 *   export default function MyComponent() {
 *     useSEO(DASHBOARD_SEO);
 *     // component code
 *   }
 */
export const ROUTE_SEO_MAP = {
  "/": DASHBOARD_SEO,                     // Bien - My Properties/Information
  "Payement": PAYMENT_SEO,                // Payement - Online Payment
  "QuittancesPayees": RECEIPTS_SEO,       // QuittancesPayees - Paid Receipts
  "QuittancesNonPayees": RECEIPTS_SEO,    // QuittancesNonPayees - Unpaid Receipts
  "operations_client": RECEIPTS_SEO,      // MyOperations - Payment History
  "derogation": HELP_SEO,                 // Derogation - Request/Help
  "doleance": HELP_SEO,                   // Doleance - Complaint/Help
  "miseendemeure": HELP_SEO,              // Miseendemeure - Enforcement/Help
  "movement-contrat": HELP_SEO,           // MovementContrat - Contract Change/Help
  "sondage": HELP_SEO,                    // Sondage - Survey/Help
  "Login": LOGIN_SEO,                     // Login - Authentication
};

export const RoutesConfig = (code) => {
  return [
    {
      path: "/",
      element: <SharedLayout />,
      protected: true,
      children: [
        { path: "/" ,index: true, element: <Bien /> },
        { path: "Payement", element: <Payement /> },
        { path: "Seccuss/:orderNumber", element: <Seccuss /> },
        { path: "PayementError/:orderNumber", element: <ErrorPayement /> },
        {
          path: "ErrorRedirectionPayement",
          element: <ErrorRedirectionPayement />,
        },
        { path: "QuittancesPayees", element: <QuittancesPayees /> },
        { path: "QuittancesNonPayees", element: <QuittancesNonPayees /> },
        { path: "operations_client", element: <MyOperations /> },
        { path: "derogation", element: <Derogation /> },
        { path: "derogation/edit/:id", element: <UpdateDerogation /> },
        { path: "doleance", element: <Doleance /> },
        { path: "nouveau-derogation", element: <NewDerogation /> },
        { path: "nouveau-doleance", element: <NewDoleance /> },
        { path: "miseendemeure", element: <Miseendemeure /> },
        { path: "movement-contrat", element: <MovementContrat /> },
        { path: "sondage", element: <Sondage /> },
      ],
    },
    {
      path: "/Error",
      element: <SharedLayout />,
      children: [
        { path: "/Error", element: <ErrorReponse status={code} /> },
        { path: "/ErrorNetwork", element: <ErrorNetwork /> },
        { path: "*", element: <Error404 /> },
      ],
    },
    { path: "/Login", element: <Login />, protected: false },
  ];
};
